import { ref as s, computed as i, toValue as q } from "vue";
import { isEmpty as f } from "../../../utils/isEmpty.js";
import { isError as O } from "../Form.helpers.js";
const j = (t, u) => u != null && u.value ? t in u.value && !!u.value[t] : !1, k = (t, u) => u ? t in u.value && u.value[t] : !1;
function R(t, u, d) {
  const l = s(), e = s(), n = s(!1), r = i(() => e.value && !f(e.value) && Object.values(e.value).some((a) => !f(a))), V = i(() => n.value && r.value), E = i(() => n.value ? e.value ?? {} : {}), h = i(() => !r.value);
  function b() {
    n.value = !0;
  }
  function p() {
    n.value = !1, l.value = {}, e.value = {};
  }
  function c(a) {
    l.value ?? (l.value = {});
    const o = q(d);
    l.value[a] = o(
      a,
      t.value[a],
      t.value
    );
    const v = l.value[a];
    e.value ?? (e.value = {}), O(v) ? e.value[a] = v : delete e.value[a];
  }
  const m = i(() => {
    if (!t.value) return [];
    function a(o) {
      return k(o, u) || j(o, e);
    }
    return Object.keys(t.value).filter(a);
  });
  function y() {
    m.value.forEach(c);
  }
  function F() {
    Object.keys(t.value).forEach(
      (a) => c(a)
    );
  }
  return {
    validateOnlyDirtyAndInErrorFields: y,
    validateAllFields: F,
    errors: e,
    hasError: r,
    visibleErrors: E,
    hasVisibleError: V,
    shouldShowErrors: n,
    isValid: h,
    makeErrorsVisible: b,
    resetValidation: p
  };
}
export {
  R as useValidation
};
